module.exports = __webpack_public_path__ + "assets/img/advantage-item2.05bb6874.png";